export const INVEST_IN_VC_FUNDS_OPTIONS = [
  { label: 'Early stage', value: 'early-stage' },
  { label: 'Late stage', value: 'late-stage' },
  { label: 'Fund-of-funds', value: 'fund-of-funds' },
  { label: 'Growth', value: 'growth' },
];
